import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import type { NotificationFindInterface } from '@zaoblako/shared/modules/notification/dtos/notification-find.dto';
import { NotificationService } from '@zaoblako/web/core/services/notification/notification.service';
import { WebsocketNotificationService } from '@zaoblako/web/core/services/notification/websocket-notification.service';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { LkEuNotificationListComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/notification-panel/notification-list/lk-eu-notification-list.component';
import { ConvertNotificationToLinkPipe } from '@zaoblako/web/shared/pipes/convert-notification-to-link.pipe';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import { TruncatePipe } from '@zaoblako/web/shared/pipes/truncate.pipe';
import { Toast, ToastModule } from 'primeng/toast';

@Component({
  standalone: true,
  selector: 'crm-lk-eu-notification-panel',
  host: { class: 'lk-eu-notification-panel' },
  templateUrl: './lk-eu-notification-panel.component.html',
  styleUrls: ['./lk-eu-notification-panel.component.scss'],
  imports: [CommonModule, LkEuNotificationListComponent, ToastModule, TruncatePipe, SafeHtmlPipe],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LkEuNotificationPanelComponent implements OnInit {
  public constructor(
    private readonly authService: AuthService,
    private readonly websocketNotificationService: WebsocketNotificationService,
    private readonly notificationService: NotificationService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly router: Router
  ) {}

  public ngOnInit(): void {
    this.websocketNotificationService.createWSConnection(
      this.authService.getToken,
      this.authService?.currentUser?.id,
      true
    );

    this.notificationService.getUnreadNotificationCount().subscribe((unreadCount) => {
      this.notificationService.unreadCount$.next(unreadCount);
    });
  }

  public toSocketNotification(notification: any): NotificationFindInterface {
    return notification as NotificationFindInterface;
  }

  public onNotificationClick(toast: Toast, notification: NotificationFindInterface) {
    toast.messages = toast.messages.filter((message) => message.data.id !== notification.id);
    this.cdRef.detectChanges();

    this.notificationService.markOneAsRead(notification.id).subscribe(() => {
      this.websocketNotificationService.socketNotificationRead$.next(notification);
    });
    this.router.navigate([new ConvertNotificationToLinkPipe().transform(notification)]).catch(console.error);
  }
}
